import React from 'react';
import { motion } from 'framer-motion';
import { FiCode, FiZap, FiStar } from 'react-icons/fi';
import './Hero.css';

const Hero = () => {
  // Detect if user is on mobile for optimized animations
  const isMobile = window.innerWidth <= 768;
  
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: isMobile ? 0.2 : 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { y: isMobile ? 30 : 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: isMobile ? 0.6 : 0.8,
        ease: "easeOut"
      }
    }
  };

  const scrollToProjects = () => {
    const element = document.getElementById('projects');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <div className="floating-shapes">
          <motion.div 
            className="shape shape-1"
            animate={{ 
              rotate: 360,
              scale: [1, 1.2, 1]
            }}
            transition={{ 
              rotate: { duration: 20, repeat: Infinity, ease: "linear" },
              scale: { duration: 4, repeat: Infinity, ease: "easeInOut" }
            }}
          />
          <motion.div 
            className="shape shape-2"
            animate={{ 
              rotate: -360,
              y: [0, -30, 0]
            }}
            transition={{ 
              rotate: { duration: 15, repeat: Infinity, ease: "linear" },
              y: { duration: 6, repeat: Infinity, ease: "easeInOut" }
            }}
          />
          <motion.div 
            className="shape shape-3"
            animate={{ 
              rotate: 180,
              x: [0, 20, 0]
            }}
            transition={{ 
              rotate: { duration: 25, repeat: Infinity, ease: "linear" },
              x: { duration: 8, repeat: Infinity, ease: "easeInOut" }
            }}
          />
        </div>
      </div>
      
      <div className="container">
        <motion.div 
          className="hero-content"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.h1 
            className="hero-title"
            variants={itemVariants}
          >
            <span className="title-line">Building Digital</span>
            <span className="title-line gradient-text">Experiences</span>
          </motion.h1>
          
          <motion.p 
            className="hero-subtitle"
            variants={itemVariants}
          >
            Professional web development, custom software solutions, and innovative digital products 
            that bring your ideas to life.
          </motion.p>
          
          <motion.div 
            className="hero-features"
            variants={itemVariants}
          >
            <div className="feature">
              <FiCode className="feature-icon" />
              <span>Custom Development</span>
            </div>
            <div className="feature">
              <FiZap className="feature-icon" />
              <span>Fast & Efficient</span>
            </div>
            <div className="feature">
              <FiStar className="feature-icon" />
              <span>Premium Quality</span>
            </div>
          </motion.div>
          
          <motion.div 
            className="hero-buttons"
            variants={itemVariants}
          >
            <motion.button 
              className="btn btn-primary"
              onClick={scrollToProjects}
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
            >
              View Projects
            </motion.button>
            <motion.button 
              className="btn btn-secondary"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
            >
              Get In Touch
            </motion.button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
